export const COMPANY_INFO = {
  name: "OP Rengøringsservice",
  brandName: "OP SERVICE",
  slogan: "– I GO’E HÆNDER",
  address: "Skalhuse 13, 9240 Nibe",
  street: "Skalhuse 13",
  city: "9240 Nibe",
  phone: "(+45) 98 35 15 47",
  phoneRaw: "+4598351547",
  email: "info@opservice.dk",
  facebook: "https://www.facebook.com/ServiceOP/",
  logoUrl: "https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/logo-gennemsigtig-sort.png",
  faviconUrl: "https://assets.auxodev.dk/assets/2c387ddb-b88b-45a9-8d4d-8c9017ed8767/cropped-logo-gennemsigtig-sort-32x32.png",
  employeesCount: "Mere end 20 kompetente medarbejdere"
};

export const SVANEMAERKET_NOTE = "Svanemærket logo afventer levering og godkendelse fra kunden";

export const MENU_ITEMS = [
  {
    label: "Forside",
    href: "/"
  },
  {
    label: "Vi tilbyder",
    href: "/ydelser",
    children: [
      { label: "Rengøring privat", href: "/ydelser/rengoering-privat" },
      { label: "Rengøring erhverv", href: "/ydelser/rengoering-erhverv" },
      { label: "Snerydning", href: "/ydelser/snerydning" },
      { label: "Haveservice", href: "/ydelser/haveservice" },
      { label: "Vinduespolering", href: "/ydelser/vinduespolering" },
      { label: "Måtteservice", href: "/ydelser/maatteservice" },
      { label: "Tagrenderensning", href: "/ydelser/tagrenderensning" }
    ]
  },
  {
    label: "Hvem er vi?",
    href: "/hvem-er-vi"
  },
  {
    label: "Kontakt",
    href: "/kontakt"
  }
];

export const SCRAPED_REVIEWS = [
  {
    author: "Lars",
    comment: "Vi har brugt OP Service i mange år og altid været tilfredse og glade for deres hjælp og professionalitet, både på erhverv og privat. De overholder altid, hvad de lover og finder altid løsninger, hvis der er udfordringer."
  },
  {
    author: "Eva",
    comment: "Vi har efterhånden brugt OP Rengøring i 12 år, simpelthen fordi vi er fuldt tilfredse med deres service. Aftaler bliver overholdt, kommunikationen er problemfri, og vi har altid følt os trykke ved deres medarbejdere."
  }
];
